export const isSpecialMouseEvent = e => {
  const button = e.buttons || e.button || e.which;
  return button !== 1 || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey;
};

export const preventDefault = e => {
  e.preventDefault();
};
